import { Fragment } from 'react'
import { GetStaticProps, GetStaticPropsContext, NextPage } from 'next'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import BookingHome from '~/booking/pages/booking-home/BookingHome.component'
import { COMMON_TRANSLATION_MODULE_NAMES, DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'
import { DefaultLayout } from '~/shared/layouts/DefaultLayout'
import { usePageTitle } from '~/utils/tags'
import Metatags from '~/components/Metadata/Metatags'

const BookingIndexPage: NextPage = (): React.ReactElement => {
  const { t } = useTranslation('booking')
  const title = usePageTitle(t('title'))

  return (
    <Fragment>
      <Metatags metaDescription={t('metaDescriptions.index')} title={title} />
      <DefaultLayout>
        <BookingHome />
      </DefaultLayout>
    </Fragment>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }: GetStaticPropsContext) => ({
  props: {
    ...(await serverSideTranslations(locale as string, [
      ...DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES,
      ...COMMON_TRANSLATION_MODULE_NAMES,
      'booking',
      'landing',
      'fields',
      'chat',
      'tutorOnDemand',
    ])),
  },
})

export default BookingIndexPage
